import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../Context';

const GetUserField = ({ fieldName, defaultValue = '...', onLoad }) => {
  const { user } = useContext(UserContext);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const config = {
          headers: { Authorization: `Bearer ${token}` }
        };

        const response = await axios.get('/api/user', config);
        const currentUser = response.data.find(u => u.matricule === user);
        
        if (!currentUser) {
          throw new Error('Utilisateur non trouvé');
        }
        
        if (currentUser[fieldName] !== undefined) {
          if (onLoad) onLoad(currentUser[fieldName]); // Transmet la valeur via callback
        } else {
          throw new Error(`Le champ ${fieldName} n'existe pas`);
        }
      } catch (err) {
        setError('Erreur lors de la récupération des données: ' + 
          (err.response?.data?.message || err.message));
        console.error(err);
      }
    };

    if (user) {
      fetchUserInfo();
    }
  }, [user, fieldName, onLoad]);

  // Ne rien rendre visuellement
  return null;
};

export default GetUserField;

